import { useContext } from 'react'
import { ThemeProviderContext } from './contexts'

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined) throw new Error('useTheme must be used within a ThemeProvider')

  return context
}

export const useAppliedTheme = () => {
  const { theme } = useTheme()

  return {
    appliedTheme: theme,
    isDarkTheme: theme === 'dark',
    isLightTheme: theme === 'light',
  }
}
